<script setup lang="ts"></script>

<template>
  <button class="flex items-center">
    <font-awesome-icon
      size="lg"
      :icon="['fas', 'arrow-left']"
      class="mr-4"
    ></font-awesome-icon>
    <slot />
  </button>
</template>
